module.exports = __webpack_public_path__ + "img/CH7.f4583c80.jpg";